<template>
  <div class="main" :style="isScrollForAbout && !isFocusSearchWidget ? {'overflow-y': 'auto'} : {}">
    <img class="logo" :src="util.getImagePath(`promptpai_logo_${$i18n.locale}@original.png`)" :class="{hide: isFocusSearchWidget}">
    <div class="search-widget-container" :class="{'focus': isFocusSearchWidget}">
      <SearchWidget :keyword.sync="keyword" />
    </div>
    <div class="button-action-container" :class="{hide: isFocusSearchWidget}">
      <div class="qr-button-container">
        <button class="qr-button" @click="clickQrButton">
          <img :src="util.getImagePath('qr_btn@2x.png')" :srcset="util.getImageSet('qr_btn')">
        </button>
        <label>{{ $t('Main.scanQr') }}</label>
      </div>
      <div class="create-new-place-button-container">
        <a href="/map/create" class="create-new-place-button" @click="clickCreateNewPlaceButton">
          <img :src="util.getImagePath('create_pin_btn@2x.png')" :srcset="util.getImageSet('create_pin_btn')">
        </a>
        <label>{{ $t('Main.createPlace') }}</label>
      </div>
    </div>
    <div class="my-place-container" v-if="!isShowAbout">
      <div class="loading-animation" v-show="!favoriteList || !recentList"></div>
      <div class="header" v-if="favoriteList && recentList">
        <button class="tab" :class="{active: currentTab === 1}" @click="currentTab = 1">
          <img v-if="currentTab !== 1" :src="util.getImagePath('recent_outline_gray@2x.png')" :srcset="util.getImageSet('recent_outline_gray')">
          <img v-if="currentTab === 1" :src="util.getImagePath('recent_blue@2x.png')" :srcset="util.getImageSet('recent_blue')">
          <label>{{ $t('Main.recents') }}</label>
        </button>
        <button class="tab" :class="{active: currentTab === 2}" @click="currentTab = 2">
          <img v-if="currentTab !== 2" :src="util.getImagePath('star_outline_gray@2x.png')" :srcset="util.getImageSet('star_outline_gray')">
          <img v-if="currentTab === 2" :src="util.getImagePath('star_blue@2x.png')" :srcset="util.getImageSet('star_blue')">
          <label>{{ $t(`Main.favPlace`) }}</label>
        </button>
        <!-- <button class="view-on-map" @click="clickViewOnMapButton" :title="$t('Main.viewOnMap')" v-if="currentTab === 2">
          <img :src="util.getImagePath('map_white@2x.png')" :srcset="util.getImageSet('map_white')">
        </button> -->
      </div>
      <div ref="recentList" class="my-place-list" v-if="favoriteList && recentList" v-show="currentTab === 1" @scroll="scrollRecentList">
        <div class="empty" v-if="recentList.length <= 0">{{ $t('Main.notFoundRecents')}}</div>
        <button class="my-place-button" v-for="(recent, index) in recentList" :key="`recent-${index}`">
          <MiniRecentPlaceCard class="my-place"
            :categoryIconPath="recent.iconfilename"
            :categoryIconHdPath="recent.iconfilename_hd"
            :recentType="recent.recent_type"
            :code="recent.promptpai_id"
            :nameTh="recent.promptpai_name_th"
            :nameEn="recent.promptpai_name_en"
            :contactName="recent.recent_type === 'S' ? (recent.receiver !== null ? recent.receiver.display_name : '') : (recent.sender !== null ? recent.sender.display_name : '')"
            :timestamp="Number(recent.timestamp)"
            @clickMiniRecentPlaceCard="$router.push(`/p/${recent.promptpai_id}`)" />
        </button>
      </div>
      <div ref="favoriteList" class="my-place-list" v-if="favoriteList && recentList" v-show="currentTab === 2" @scroll="scrollFavoriteList">
        <div class="empty" v-if="favoriteList.length <= 0">{{ $t('Main.notFoundFavPlace')}}</div>
        <button class="my-place-button" v-for="(myPlace, index) in favoriteList" :key="`my-place-${index}`">
          <MiniPlaceCard class="my-place"
            :categoryIconPath="myPlace.iconfilename"
            :categoryIconHdPath="myPlace.iconfilename_hd"
            :isFav="myPlace.marked_favorite"
            :code="myPlace.promptpai_id"
            :nameTh="myPlace.promptpai_name_th"
            :nameEn="myPlace.promptpai_name_en"
            :addressTh="myPlace.promptpai_address_th"
            :addressEn="myPlace.promptpai_address_en"
            @clickMiniPlaceCard="$router.push(`/p/${myPlace.promptpai_id}`)" />
        </button>
      </div>
    </div>
    <div class="about-bg" v-if="isShowAbout">
      <div class="about" v-if="isShowAbout">
        <div class="section what">
          <div><img :src="util.getImagePath('about_what@2x.png')" :srcset="util.getImageSet('about_what')"></div>
          <div>
            <div class="head">
              {{ $t('Main.whatIsPromptPai.topic') }}
              <div></div>
            </div>
            <p style="text-indent: 32px; text-align: justify;">{{ $t('Main.whatIsPromptPai.description1') }}</p>
          </div>
        </div>
        <div class="section format">
          <div>
            <div class="head">{{ $t('Main.whatIsFormat.topic') }}<div></div></div>
            <ul>
              <li><span class="bold">{{ $t('Main.whatIsFormat.description1') }}</span>{{ $t('Main.whatIsFormat.description2') }}</li>
              <li><span class="bold">{{ $t('Main.whatIsFormat.description3') }}</span>{{ $t('Main.whatIsFormat.description4') }}</li>
            </ul>
          </div>
          <div style="text-align: right;"><img :src="util.getImagePath(`about_format_${$i18n.locale}@2x.png`)" :srcset="util.getImageSet(`about_format_${$i18n.locale}`)"></div>
        </div>
        <div class="section how">
          <div class="head">{{ $t('Main.howToUse.topic') }}<div></div></div>
          <div class="body">
            <div>
              <img :src="util.getImagePath('about_how_search@2x.png')" :srcset="util.getImageSet('about_how_search')">
              <p><span class="bold">{{ $t('Main.howToUse.description1') }}</span><br>{{ $t('Main.howToUse.description2') }}<br>{{ $t('Main.howToUse.description3') }}<br>{{ $t('Main.howToUse.description4') }}</p>
            </div>
            <div>
              <img :src="util.getImagePath('about_how_url@2x.png')" :srcset="util.getImageSet('about_how_url')">
              <p><span class="bold">{{ $t('Main.howToUse.description5') }}</span><br>{{ $t('Main.howToUse.description6') }}<br>{{ $t('Main.howToUse.description7') }}<br>{{ $t('Main.howToUse.description8') }}</p>
            </div>
            <div>
              <img :src="util.getImagePath('about_how_qr@2x.png')" :srcset="util.getImageSet('about_how_qr')">
              <p><span class="bold">{{ $t('Main.howToUse.description9') }}</span><br>{{ $t('Main.howToUse.description10') }}</p>
            </div>
          </div>
        </div>
        <div class="section award">
          <div class="head">{{ $t('Main.award.topic') }}<div></div></div>
          <div class="body">
            <a href="https://mm.co.th/node/132" @click="clickAward">
              <img style="max-width: 320px; cursor: pointer;" :src="util.getImagePath('award_home1@2x.png')" :srcset="util.getImageSet('award_home1')">
            </a>
            <a href="https://mm.co.th/node/132" @click="clickAward">
              <img style="max-width: 320px; cursor: pointer;" :src="util.getImagePath('award_home2@2x.png')" :srcset="util.getImageSet('award_home2')">
            </a>
          </div>
        </div>
        <div class="section download" v-if="showDownload">
          <div class="head">{{ $t('Main.download.topic') }}<div></div></div>
          <div class="body">
            <DownloadApp/>
          </div>
        </div>
        <div class="section line">
          <div class="head">{{ $t('Main.line.topic') }}<div></div></div>
          <div class="body">
            <a href="https://lin.ee/tdLwtpH" @click="clickLine"><img :src="`https://scdn.line-apps.com/n/line_add_friends/btn/${$i18n.locale}.png`" alt="@promptpai" height="36" border="0"></a>
            <div class="account-id">@promptpai</div>
          </div>
        </div>
        <div class="link-action-container">
          <router-link class="about-bottom" tag="a" to="/about">{{ $t('Main.getToKnow') }}</router-link>
          <button class="goto-top-bottom" @click="clickGotoTopButton">
            <img :src="util.getImagePath('back_white@2x.png')" :srcset="util.getImageSet('back_white')">
          </button>
        </div>
      </div>
    </div>
    <div class="footer-bg" :class="{'show-about': isShowAbout}">
      <div class="footer" v-if="isShowAbout || (favoriteList && recentList)">
          <a href="https://mm.co.th" class="mm" @click="clickMM">© Metamedia Technology Co., Ltd.</a>
          <a href="/about" class="ws" @click="clickAbout">{{ $t('Main.about') }}</a>
          <a href="/ws" class="ws" @click="clickDev">PromptPai API</a>
          <a href="/ws/pplist" class="pp-list" @click="clickPromptPaiList">{{ $t('Main.ppList') }}</a>
          <div>
            <a href="https://lin.ee/tdLwtpH" @click="clickLine" class="line">
              <img :src="util.getImagePath('line@2x.png')" :srcset="util.getImageSet('line')">
            </a>
            <a href="https://www.facebook.com/promptpainow" @click="clickFacebook" class="facebook">
              <img :src="util.getImagePath('share_facebook@2x.png')" :srcset="util.getImageSet('share_facebook')">
            </a>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchWidget from '@/components/SearchWidget.vue'
import MiniPlaceCard from '@/components/MiniPlaceCard.vue'
import MiniRecentPlaceCard from '@/components/MiniRecentPlaceCard.vue'
import DownloadApp from '@/components/DownloadApp.vue'

export default {
  name: 'Main',
  components: {
    SearchWidget,
    MiniPlaceCard,
    MiniRecentPlaceCard,
    DownloadApp
  },
  metaInfo () {
    return {
      title: 'พร้อมไป ไปถึงทุกที่ไม่มีพลาด',
      meta: [
        {
          name: 'description',
          content: 'การระบุตำแหน่งสถานที่โดยใช้ตัวเลข (Map code) แทนข้อมูลที่อยู่ ชื่อสถานที่ พิกัด Latitude Longitude หรือข้อมูลอื่นที่เกี่ยวข้องกับสถานที่นั้น'
        },
        {
          name: 'keywords',
          content: 'พร้อมไป, PromptPai'
        },
        {
          property: 'fb:app_id',
          content: '148173948530677'
        },
        {
          property: 'og:site_name',
          content: 'PromptPai'
        },
        {
          property: 'og:image',
          content: 'https://promptpai.com/static/image/promptpai_app_icon_xxxhdpi.png'
        },
        {
          property: 'og:image:type',
          content: 'image/png'
        },
        {
          property: 'og:url',
          content: 'https://promptpai.com'
        },
        {
          property: 'og:description',
          content: 'การระบุตำแหน่งสถานที่โดยใช้ตัวเลข (Map code) แทนข้อมูลที่อยู่ ชื่อสถานที่ พิกัด Latitude Longitude หรือข้อมูลอื่นที่เกี่ยวข้องกับสถานที่นั้น'
        },
        {
          property: 'og:title',
          content: 'พร้อมไป ไปถึงทุกที่ไม่มีพลาด'
        }
      ]
    }
  },
  data () {
    return {
      keyword: '',
      searchResult: undefined,
      isFocusSearchWidget: false,
      isSearchWidgetSlideEnterActive: false,
      isSearchWidgetSlideLeaveActive: false,
      windowWidth: document.documentElement.clientWidth,
      currentTab: 1
    }
  },
  mounted () {
    var self = this
    self.checkActions()
    self.recents()
    self.myPlace()
    if ('uid' in self.$route.query) {
      if ('ppid' in self.$route.query) {
        self.$root.$emit('openModal', {
          name: 'SendPlaceForm',
          uid: self.$route.query.uid,
          selectedPromptpaiId: self.$route.query.ppid
        })
      } else {
        self.$root.$emit('openModal', {
          name: 'SendPlaceForm',
          uid: self.$route.query.uid
        })
      }
    }
    self.$root.$emit('showTopNavbar')
    var myPlaceTab = JSON.parse(self.getPromptPaiCookies('myPlaceTab'))
    switch (myPlaceTab) {
      case 'Recent': {
        self.currentTab = 1
        break
      }
      case 'Favorite': {
        self.currentTab = 2
        break
      }
      default: {
        self.setPromptPaiCookies('myPlaceTab', JSON.stringify('Favorite'), Infinity, '/')
        self.currentTab = 2
        break
      }
    }

    self.$root.$on('windowResize', self.windowResize)
    self.$root.$on('focusSearchWidget', self.focusSearchWidget)
    self.$root.$on('blurSearchWidget', self.blurSearchWidget)
  },
  computed: {
    isScrollForAbout () {
      var self = this
      return self.isShowAbout && self.windowWidth <= 768
    },
    isShowAbout () {
      var self = this
      var favoriteLength = 0
      var recentLength = 0
      if (self.favoriteList) {
        favoriteLength = self.favoriteList.length
      }
      if (self.recentList) {
        recentLength = self.recentList.length
      }
      if (favoriteLength > 0 || recentLength > 0 || (self.favoriteList === undefined && self.recentList === undefined)) {
        return false
      }
      return true
    },
    showDownload () {
      return this.util.getUserAgentMeta() !== 'Android application' && this.util.getUserAgentMeta() !== 'iOS application'
    }
  },
  methods: {
    checkActions () {
      var self = this
      if ('action' in self.$route.query) {
        var action = self.$route.query.action
        if (action === 'loginagain') {
          self.$root.$emit('logout', false)
          self.$router.replace('/')
          self.recents()
          self.myPlace()
          self.$root.$emit('openModal', {
            name: 'Login'
          })
        } else if (action === 'activatedemail') {
          var username = self.$route.query.username
          var isAuthenticated = JSON.parse(self.getPromptPaiCookies('isAuthenticated'))
          if (isAuthenticated) {
            self.$root.$emit('logout', false)
          }
          self.$router.replace('/')
          self.recents()
          self.myPlace()
          self.$root.$emit('openModal', {
            name: 'Login',
            initUsername: username,
            isActivatedMode: true
          })
        } else if (action === 'resetpassword') {
          // var username = self.$route.query.username
          var oneTimeToken = self.$route.query.onetimetoken
          // login with username and oneTimeToken
          self.$router.replace('/')
          self.recents()
          self.myPlace()
          self.$root.$emit('openModal', {
            name: 'EditProfile',
            isResetPassword: true,
            oneTimeToken: oneTimeToken
          })
        }
      }
    },
    windowResize () {
      var self = this
      self.windowWidth = document.documentElement.clientWidth
    },
    focusSearchWidget () {
      var self = this
      self.isFocusSearchWidget = true
    },
    blurSearchWidget () {
      var self = this
      self.isFocusSearchWidget = false
    },
    onDecode (decodedString) {
      alert(decodedString)
    },
    myPlace () {
      var self = this
      var userProfile = {}
      var uuid = JSON.parse(self.getPromptPaiCookies('Uuid'))
      var isAuthenticated = JSON.parse(self.getPromptPaiCookies('isAuthenticated'))
      if (isAuthenticated) {
        userProfile = JSON.parse(self.getPromptPaiCookies('UserProfile'))
        uuid = undefined
      }
      self.pp.getFavoritePlaces(
        'name' in userProfile ? userProfile.name : undefined,
        'longdousertoken' in userProfile ? userProfile.longdousertoken : undefined,
        isAuthenticated ? undefined : uuid,
        self.itemsPerPage,
        self.itemsPerPage * (self.favoritePage - 1),
        undefined,
        (result) => {
          if (result.status.code === 200) {
            if (self.favoritePage > 1) {
              self.mergeFavoriteList(result.data)
            } else {
              self.setFavoriteList(result.data)
            }
          } else if (result.status.code === 401) {
            self.loginAgain()
          } else if (result.status.code === 403) {
          } else {
          }
        }
      )
    },
    scrollFavoriteList () {
      var self = this
      var element = self.$refs['favoriteList']
      var diff = element.scrollHeight - Math.floor(element.scrollTop) - element.clientHeight
      var error = 0
      if (diff >= (-1 * error) && diff <= error) {
        self.setFavoritePage(self.favoritePage + 1)
        self.myPlace()
      }
    },
    clickQrButton () {
      var self = this
      self.$root.$emit('openModal', {
        name: 'QrReader'
      })
    },
    clickCreateNewPlaceButton (e) {
      e.preventDefault()
      var self = this
      self.$router.push('/map/create')
      return false
    },
    clickViewOnMapButton () {
      var self = this
      self.$router.push('/map/myplace/@13.764955,100.538317,6,1,0')
    },
    recents () {
      var self = this
      var userProfile = {}
      var uuid = JSON.parse(self.getPromptPaiCookies('Uuid'))
      var isAuthenticated = JSON.parse(self.getPromptPaiCookies('isAuthenticated'))
      if (isAuthenticated) {
        userProfile = JSON.parse(self.getPromptPaiCookies('UserProfile'))
        uuid = undefined
      }
      self.pp.getRecentPlaces(
        'name' in userProfile ? userProfile.name : undefined,
        'longdousertoken' in userProfile ? userProfile.longdousertoken : undefined,
        uuid,
        self.itemsPerPage,
        'all',
        self.itemsPerPage * (self.recentPage - 1),
        undefined,
        (result) => {
          if (result.status.code === 200) {
            if (self.recentPage > 1) {
              self.mergeRecentList(result.data)
            } else {
              self.setRecentList(result.data)
            }
          } else if (result.status.code === 401) {
            self.loginAgain()
          } else if (result.status.code === 403) {
          } else {
          }
        }
      )
    },
    scrollRecentList () {
      var self = this
      var element = self.$refs['recentList']
      var diff = element.scrollHeight - Math.floor(element.scrollTop) - element.clientHeight
      var error = 0
      if (diff >= (-1 * error) && diff <= error) {
        self.setRecentPage(self.recentPage + 1)
        self.recents()
      }
    },
    clickGotoTopButton () {
      document.querySelector('#app').scrollTop = '0px'
      document.querySelector('.main').scrollTop = '0px'
    },
    clickAward (e) {
      e.preventDefault()
      var self = this
      var userAgent = self.util.getUserAgentMeta()
      var url = `https://mm.co.th/node/132`
      window.gtag('config', 'UA-143787399-1', {
        'page_path': url
      })
      if (userAgent === 'iOS application') {
        window.location.href = `https://native.openUrl?url=${encodeURIComponent(url)}`
      } else if (userAgent === 'Android application') {
        Android.openUrl(url)
      } else {
        window.open(url, '_blank')
      }
      return false
    },
    clickFacebook (e) {
      e.preventDefault()
      var self = this
      var userAgent = self.util.getUserAgentMeta()
      var url = `https://www.facebook.com/promptpainow`
      window.gtag('config', 'UA-143787399-1', {
        'page_path': url
      })
      if (userAgent === 'iOS application') {
        window.location.href = `https://native.openUrl?url=${encodeURIComponent(url)}`
      } else if (userAgent === 'Android application') {
        Android.openUrl(url)
      } else {
        window.open(url, '_blank')
      }
      return false
    },
    clickLine (e) {
      e.preventDefault()
      var self = this
      var userAgent = self.util.getUserAgentMeta()
      var url = `https://lin.ee/tdLwtpH`
      window.gtag('config', 'UA-143787399-1', {
        'page_path': url
      })
      if (userAgent === 'iOS application') {
        window.location.href = `https://native.openUrl?url=${encodeURIComponent(url)}`
      } else if (userAgent === 'Android application') {
        Android.openUrl(url)
      } else {
        window.open(url, '_blank')
      }
      return false
    },
    clickMM (e) {
      e.preventDefault()
      var self = this
      var userAgent = self.util.getUserAgentMeta()
      var url = `https://mm.co.th`
      window.gtag('config', 'UA-143787399-1', {
        'page_path': url
      })
      if (userAgent === 'iOS application') {
        window.location.href = `https://native.openUrl?url=${encodeURIComponent(url)}`
      } else if (userAgent === 'Android application') {
        Android.openUrl(url)
      } else {
        window.open(url, '_blank')
      }
      return false
    },
    clickAbout (e) {
      e.preventDefault()
      var self = this
      self.$router.push('/about')
      return false
    },
    clickDev (e) {
      e.preventDefault()
      var self = this
      var userAgent = self.util.getUserAgentMeta()
      window.gtag('config', 'UA-143787399-1', {
        'page_path': '/ws'
      })
      var url = `${window.location.origin}/ws`
      if (userAgent === 'iOS application') {
        window.location.href = `https://native.openUrl?url=${encodeURIComponent(url)}`
      } else if (userAgent === 'Android application') {
        Android.openUrl(url)
      } else {
        window.open(url, '_blank')
      }
      return false
    },
    clickPromptPaiList (e) {
      e.preventDefault()
      var self = this
      var userAgent = self.util.getUserAgentMeta()
      self.isOpenMenuPanel = false
      window.gtag('config', 'UA-143787399-1', {
        'page_path': '/ws/pplist'
      })
      var url = `${window.location.origin}/ws/pplist`
      if (userAgent === 'iOS application') {
        window.location.href = `https://native.openUrl?url=${encodeURIComponent(url)}`
      } else if (userAgent === 'Android application') {
        Android.openUrl(url)
      } else {
        window.open(url, '_blank')
      }
      return false
    }
  },
  watch: {
    '$route' () {
      var self = this
      self.$nextTick(() => {
        self.checkActions()
      })
    },
    currentTab () {
      var self = this
      self.$nextTick(() => {
        switch (self.currentTab) {
          case 1: {
            window.gtag('event', 'view_item_list', {'event_label': `view_recent_list`})
            self.setPromptPaiCookies('myPlaceTab', JSON.stringify('Recent'), Infinity, '/')
            break
          }
          case 2: {
            window.gtag('event', 'view_item_list', {'event_label': `view_my_place_list`})
            self.setPromptPaiCookies('myPlaceTab', JSON.stringify('Favorite'), Infinity, '/')
            break
          }
        }
      })
    }
  },
  beforeDestroy () {
    var self = this
    self.$root.$off('focusSearchWidget')
    self.$root.$off('blurSearchWidget')
  }
}
</script>

<style scoped>
  .main {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  img.logo {
    height: 110px;
    margin: 65px auto 0px auto;
    width: 100%;
    object-fit: scale-down;
  }

  .search-widget-container {
    width: 100%;
    max-width: 500px;
    margin: 32px auto 0px auto;
    z-index: 10;
  }

  .button-action-container {
    display: flex;
    flex-direction: row;
    margin: 55px auto 0px auto;
    width: 320px;
  }

  .qr-button-container,
  .create-new-place-button-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: calc(100% / 2);
  }

  button.qr-button,
  a.create-new-place-button {
    border: none;
    width: 64px;
    height: 64px;
    padding: 0px;
    overflow: hidden;
    background-color: transparent;
    cursor: pointer;
    text-decoration: none;
  }

  button.qr-button > img,
  a.create-new-place-button > img {
    border: none;
    width: 64px;
    height: 64px;
  }

  .qr-button-container > label,
  .create-new-place-button-container > label {
    color: rgb(255, 255, 255);
    font-size: 18px;
    font-family: Prompt;
    padding-top: 4px;
  }

  .my-place-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 460px;
    flex: 1;
    margin: 50px auto 40px auto;
  }

  .my-place-container > .header {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    border-radius: 10px 10px 0px 0px;
    overflow: hidden;
    background-color: rgb(255, 255, 255);
  }

  .my-place-container > .header > button.tab {
    width: calc(100% / 2);
    height: 36px;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgb(255, 255, 255);
    cursor: pointer;
    padding: 0px;
    border-bottom: 2px solid rgb(227, 227, 227);
  }

  .my-place-container > .header > button.tab:first-child {
    border-radius: 10px 0px 0px 0px;
  }

  .my-place-container > .header > button.tab:last-child {
    border-radius: 0px 10px 0px 0px;
  }

  .my-place-container > .header > button.tab:hover {
    border-bottom: 2px solid rgb(34, 84, 156);
  }

  .my-place-container > .header > button.tab.active {
    box-shadow: 0px -5px 4px 0 rgba(0, 0, 0, 0.1);
    -webkit-appearance: none;
    border-bottom: 2px solid rgb(34, 84, 156);
    z-index: 1;
  }

  .my-place-container > .header > button.tab > img {
    height: 18px;
  }

  .my-place-container > .header > button.tab > label {
    font-family: Prompt;
    font-size: 16px;
    margin-left: 4px;
    cursor: pointer;
    color: rgb(106, 105, 105);
  }

  .my-place-container > .header > button.tab.active > label {
    color: rgb(34, 84, 156);
  }

  .my-place-container > .header > label.topic {
    font-size: 16px;
    z-index: 1;
    color: rgb(255, 255, 255);
    font-family: Prompt;
    margin-bottom: 8px;
  }

  .my-place-container > .my-place-list {
    width: 100%;
    max-height: calc(60px * 6.5);
    min-height: calc(60px * 1);
    overflow: hidden;
    overflow-y: auto;
    background-color: rgb(251, 251, 251);
    border-radius: 0px 0px 10px 10px;
  }

  .my-place-container > .my-place-list::-webkit-scrollbar-button {
    height: 12.5px;
  }
  .my-place-container > .my-place-list::-webkit-scrollbar {
    background-color: rgb(251, 251, 251);
  }
  .my-place-container > .my-place-list::-webkit-scrollbar-thumb {
    border: 2px solid rgb(251, 251, 251);
  }

  .my-place-list > .empty {
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 18px;
    color: rgb(120, 120, 120);
  }

  button.my-place-button {
    width: 100%;
    border: none;
    padding: 4px 0px 8px 0px;
    margin: 0px;
    cursor: pointer;
    background-color: transparent;
    text-align: left;
    border-bottom: 1px solid rgb(227, 227, 227);
  }

  .loading-animation {
    position: absolute;
  }

  .about-bg {
    background-image: url(/static/image_asset/white_background_2560.png);
    background-size: 100% auto;
    background-position: top center;
    background-repeat: no-repeat repeat;
    width: 100%;
    margin-top: 55px;
  }

  .about {
    font-family: Prompt-ExtraLight;
    color: rgb(74, 74, 74);
    width: 100%;
    min-width: calc(320px - 32px);
    max-width: 640px;
    margin: 40px auto 0px auto;
  }

  .about * {
    font-family: Prompt-ExtraLight;
    color: rgb(74, 74, 74);
  }

  .section {
    display: flex;
    padding-bottom: 40px;
  }

  .section * {
    font-size: 18px;
  }

  .section.what {
    flex-direction: row;
    align-items: center;
  }

  .section.what > div {
    width: 50%;
  }

  .section.what > div > img {
    width: 300px;
    height: 192px;
  }

  .section.format {
    flex-direction: row;
    align-items: center;
  }

  .section.format > div {
    width: 50%;
  }

  .section.format > div > img {
    width: 300px;
    height: 192px;
  }

  .section.how {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .section.how > .head {
    width: 100%;
    text-align: center;
  }

  .section.how > .body {
    display: flex;
    flex-direction: row;
    width: 100%;
    padding-top: 10px;
  }

  .section.how > .body > div {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: calc(100% / 3);
    text-align: center;
  }

  .section.how > .body > div > img {
    width: calc(640px / 3);
    height: calc(640px / 3);
  }

  .section .head {
    font-weight: bold;
    font-size: 28px;
  }

  .section .head > div {
    width: 100%;
    height: 2px;
    border-radius: 1px;
    background-image: linear-gradient(90deg, rgb(251, 147, 73) 0%, rgb(245, 166, 35) 50%, rgba(245, 166, 35, 0) 80%);
  }

  .section.how .head > div,
  .section.award .head > div,
  .section.download .head > div,
  .section.line .head > div {
    width: 100%;
    height: 2px;
    border-radius: 1px;
    background-image: linear-gradient(90deg, rgba(251, 147, 73, 0) 20%, rgb(251, 147, 73) 40%, rgb(245, 166, 35) 60%, rgba(245, 166, 35, 0) 80%);
  }

  .section.award,
  .section.download,
  .section.line {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-bottom: 60px;
  }

  .section.award > .head,
  .section.download > .head,
  .section.line > .head {
    width: 100%;
    text-align: center;
  }

  .section.award > .body {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-top: 10px;
    justify-content: center;
    align-items: center;
  }

  .section.award > .body > a {
    text-decoration: none;
    margin-top: 20px;
  }

  .section.download > .body {
    display: flex;
    flex-direction: row;
    width: 100%;
    padding-top: 10px;
    justify-content: center;
    align-items: center;
  }

  .section.line > .body {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-top: 10px;
    justify-content: center;
    align-items: center;
  }

  .bold {
    font-weight: bold;
  }

  .link-action-container {
    text-align: center;
    position: relative;
    display: flex;
    flex-direction: row;
  }

  .about-bottom {
    background-image: linear-gradient(-180deg, rgb(245, 166, 35) 0%, rgb(251, 147, 73) 100%);
    font-weight: bold;
    padding: 16px 32px;
    border-radius: 28px;
    border: none;
    cursor: pointer;
    margin: 0px auto 40px auto;
    text-decoration: none;
    color: rgb(255, 255, 255);
  }

  .goto-top-bottom {
    background-image: linear-gradient(-180deg, rgb(245, 166, 35) 0%, rgb(251, 147, 73) 100%);
    width: 56px;
    height: 56px;
    border-radius: 28px;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 0px;
    top: 0px;
    cursor: pointer;
  }

  .goto-top-bottom > img {
    transform: rotate(90deg);
  }

  .footer-bg {
    width: 100%;
  }

  .footer-bg.show-about {
    background-color: rgb(239, 239, 239);
  }

  .footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    min-width: calc(320px - 32px);
    max-width: 640px;
    margin: 0px auto;
  }

  .footer a {
    text-decoration: none;
    color: rgb(255, 255, 255);
    margin: 0px auto 0px 0px;
    font-size: 14px;
  }

  .footer-bg.show-about .footer a {
    color: rgb(74, 74, 74);
  }

  .footer a.line {
    margin-right: 12px;
  }

  .footer a.facebook {
    margin-right: 0px;
  }

  .footer a img {
    width: 20px;
    height: 20px;
  }

  @media only screen and (max-width: 1440px) {
    .about-bg {
      background-image: url(/static/image_asset/white_background_1440.png);
    }
  }

  @media only screen and (max-width: 1024px) {
    .about-bg {
      background-image: url(/static/image_asset/white_background_1024.png);
    }
  }

  @media only screen and (max-width: 768px) {
    .main {
      height: 100%;
      overflow: hidden;
    }
    
    img.logo {
      height: 60px;
      margin: 40px auto 0px auto;
      opacity: 1;
      /* transition: margin-top 0.15s ease 0s, opacity 0.15s ease 0s; */
    }

    img.logo.hide {
      margin-top: calc(50px - 110px);
      opacity: 0;
    }

    .search-widget-container {
      width: calc(100% - 40px);
      max-width: unset;
      margin: 18px auto 0px auto;
    }

    .search-widget-container.focus {
      margin: 18px auto 0px auto;
    }

    .button-action-container {
      margin: 35px auto 0px auto;
      /* transition: margin-top 0.15s linear 0s, opacity 0.15s linear 0s; */
      display: -webkit-box;
    }

    .button-action-container.hide {
      margin-top: calc(100vh + 18px - 40px - 35px);
      opacity: 0;
    }

    button.qr-button,
    a.create-new-place-button {
      width: 48px;
      height: 48px;
    }

    button.qr-button > img,
    a.create-new-place-button > img {
      width: 48px;
      height: 48px;
    }

    .my-place-container {
      width: 100%;
      height: calc(100% - 40px - 60px - 50px - 18px - 35px - 80px - 25px);
      max-height: calc(100% - 40px - 60px - 50px - 18px - 35px - 80px - 25px);
      flex: 1;
      margin: 25px auto 0px auto;
    }

    .my-place-container > .header {
      justify-content: flex-start;
      border-radius: 0px 0px 0px 0px;
    }

    .my-place-container > .header > button.tab {
      border-radius: 0px;
    }

    /* .my-place-container > .header > button.view-on-map {
      margin-right: 10px;
    }

    .my-place-container > .header > button.view-on-map > label {
      font-size: 14px;
    }

    .my-place-container > .header > label.topic {
      border-radius: 0px;
      margin-left: 8px;
    } */

    .my-place-container > .my-place-list {
      height: calc(100% - 36px);
      max-height: calc(100% - 36px);
      border-radius: 0px;
    }

    .my-place-list > .empty {
      height: 100%;
    }

    .about-bg {
      background-image: url(/static/image_asset/white_background_768.png);
    }

    .footer-bg.show-about {
      background-color: transparent;
      background-image: linear-gradient(180deg, rgba(240, 240, 240, 1) 0%, rgba(240, 240, 240, 1) 100%);
    }

    .footer {
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin: 24px auto 12px auto;
    }

    .footer a {
      margin: auto;
      margin-bottom: 6px;
    }

    .footer a.mm {
      order: 5;
    }

    .footer a.pp-list {
      margin-bottom: 24px;
    }

    .footer a.line {
      margin-right: auto;
    }

    .footer a.facebook {
      margin-right: auto;
    }
  }

  @media only screen and (max-width: 640px) {
    .section.what {
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .section.what > div {
      width: calc(100% - 32px);
      text-align: center;
    }

    .section.format {
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .section.format > div {
      width: calc(100% - 32px);
      text-align: center !important;
    }

    .section.format > div > img {
      align-items: center;
    }

    .section.format > div > ul {
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
      text-align: left;
    }

    .section .head > div {
      width: 100%;
      background-image: linear-gradient(90deg, rgba(251, 147, 73, 0) 20%, rgb(251, 147, 73) 40%, rgb(245, 166, 35) 60%, rgba(245, 166, 35, 0) 80%);
    }

    .section.how > .body {
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      padding-top: 0px;
    }

    .section.how > .body > div {
      justify-content: center;
      align-items: center;
      width: calc(100% - 32px);
      text-align: center;
      padding-top: 20px;
    }

    .section.how > .body > div > P {
      margin-top: 0px;
    }

    .about-bottom {
      margin: 0px 10px 40px auto;
    }

    .goto-top-bottom {
      position: inherit;
      margin: 0px auto 40px 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main.vue